<template>
  <div>
    <div class="strategy-banner">
      <div class="banner-image" :style="{backgroundImage: `url('${ikUrl}')`}"/>

      <strategy-edit-button
        class="edit-button"
        v-if="editorVisibility"
        :uuid="uuid"/>

      <div class="banner-content">
        <h2 class="banner-subtitle"> Strategy </h2>

        <h1 class="banner-title"> {{ title }} </h1>

        <p class="banner-alt-names"> {{ altNames.join(', ') }} </p>

        <p>
          <span
            v-for="udl in udlStandards"
            :key="udl.udl_checkpoint"
            :class="udlClass(udl.udl_principle)">
            UDL {{ udl.udl_checkpoint }}
          </span>
        </p>

        <WikiText class="banner-description" :text="description" />
      </div>
    </div>
  </div>
</template>

<script>
import { urlFromAWSUrl } from '@/imagekit/imageurl_from_aws_url'
import StrategyEditButton from '@/components/strategies/details/StrategyEditButton'
import WikiText from '@/components/WikiText'

import { mapGetters } from 'vuex'

export default {
  name: 'StrategyBanner',
  components: {
    StrategyEditButton,
    WikiText
  },
  props: {
    uuid: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    altNames: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    udlStandards: {
      type: Array,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('visibility', ['editorVisibility']),
    ikUrl() {
      return urlFromAWSUrl(this.imageUrl, [{ q: 50, w: 800 }])
    }
  },
  methods: {
    udlClass(principle) {
      return `label udl-${principle}`
    },
    backgroundImageStyle() {
      return ``
    }
  }
}
</script>

<style lang="less">
@import '~@/variables.less';

.strategy-banner {
  position: relative;
  min-height: 300px;
  background-color: rgba(0, 0, 0, 0.7);
  padding-top: 24px;
  padding-bottom: 48px;
  margin-bottom: 32px;
  color: #e2e2e2;
}

.banner-content {
  padding: 0 32px;
}

.banner-subtitle {
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 500;
}

.banner-title {
  color: white;
  font-size: 48px;
  font-weight: normal;
  line-height: 56px;
}

.banner-alt-names {
  color: var(--gray-inverted-weak);
}

.banner-description {
  font-size: 21px;
  font-weight: 300;
  line-height: 28px;
  margin-top: 32px;
}

.banner-image {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.edit-button {
  position: absolute;
  top: 12px;
  right: 12px;
}

/* engagement */
.udl-III {
  font-size: 12px;
  background-color: @udlEngagementDark;
  margin: 2px;
  padding: 2px 4px;
}

/* representation */
.udl-I {
  font-size: 12px;
  background-color: @udlRepresentationDark;
  margin-right: 2px;
  padding: 2px 4px;
}

/* expression */
.udl-II {
  font-size: 12px;
  background-color: @udlExpressionDark;
  margin: 2px;
  padding: 2px 4px;
}
</style>
